import { render, staticRenderFns } from "./LeftDadosCadastrais.vue?vue&type=template&id=788d3bef"
import script from "./LeftDadosCadastrais.vue?vue&type=script&lang=js"
export * from "./LeftDadosCadastrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports